import { Order } from '../../Libs/Extensions/Sort.extension';
import {
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Typography,
} from '@mui/material'

export interface IHeadTabel {
  //id: keyof IStudent
  id: string
  label: string
  align?: 'center' | 'inherit' | 'justify' | 'left' | 'right'
  sort?: boolean
  minWidth?: number
  maxWidth?: number
  width?: number
  active?: boolean
  hidden?: boolean
  disablePadding?: boolean,
}

interface IHeaderCell<T> {
  cells: readonly IHeadTabel[]
  //sortHandler?: React.MouseEventHandler<HTMLButtonElement>
   sortHandler?: any,
  order?: Order;
  orderBy?: string;
  rowCount?: number;
  onRequestSort?: (event: React.MouseEvent<unknown>, property: keyof T) => void;
  onSelectAllClick?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export default function HTable<T>(props: IHeaderCell<T>) {
  const { order, orderBy, onRequestSort } = props;

  const createSortHandler =
    (property: keyof T) => (event: React.MouseEvent<unknown>) => {
      onRequestSort?.(event, property);
    };


  //--------------------------------------------------//
  //--------------------------------------------------//
  return (
    <TableHead>
      <TableRow>
        {props.cells.map((cell) => (
          <TableCell
            key={cell.id}
            align={cell.align}
            padding={cell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === cell.id as keyof T ? order : false}
            style={{
              minWidth: cell.minWidth ?? 'auto',
              maxWidth: cell.maxWidth ?? 'auto',
              width: cell.width ?? 'auto',
            }}
          //sortDirection={orderBy === cell.id ? order : false}
          >
            {cell.sort ? (
              <TableSortLabel
                active={orderBy === (cell.id as keyof T)}
                direction={orderBy === (cell.id as keyof T) ? order : 'asc'}
                hideSortIcon={!cell.sort}
                onClick={createSortHandler(cell.id as keyof T)}
              >
                <Typography variant="h5" sx={{ lineHeight: 0.9 }}>
                  <b>{cell.label}</b>
                </Typography>
              </TableSortLabel>
            ) : (
              <Typography variant="h5" sx={{ lineHeight: 0.9 }}>
                <b>{cell.label}</b>
              </Typography>
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  )
}
